[
  {
    "code": "PL-DS",
    "name": "Dolnoslaskie"
  },
  {
    "code": "PL-KP",
    "name": "Kujawsko-pomorskie"
  },
  {
    "code": "PL-LU",
    "name": "Lubelskie"
  },
  {
    "code": "PL-LB",
    "name": "Lubuskie"
  },
  {
    "code": "PL-LD",
    "name": "Lódzkie"
  },
  {
    "code": "PL-MA",
    "name": "Malopolskie"
  },
  {
    "code": "PL-MZ",
    "name": "Mazowieckie"
  },
  {
    "code": "PL-OP",
    "name": "Opolskie"
  },
  {
    "code": "PL-PK",
    "name": "Podkarpackie"
  },
  {
    "code": "PL-PD",
    "name": "Podlaskie"
  },
  {
    "code": "PL-PM",
    "name": "Pomorskie"
  },
  {
    "code": "PL-SL",
    "name": "Slaskie"
  },
  {
    "code": "PL-SK",
    "name": "Swietokrzyskie"
  },
  {
    "code": "PL-WN",
    "name": "Warminsko-mazurskie"
  },
  {
    "code": "PL-WP",
    "name": "Wielkopolskie"
  },
  {
    "code": "PL-ZP",
    "name": "Zachodniopomorskie"
  }
]